module.exports = __webpack_public_path__ + "static/book-7a57a618f5240d1fc5954df9bc68ea66.png";